export const AT_SET_ACTION = 'CARD_ASSIGNEES_SET_ACTION';
export const AT_CARD_ASSIGNEE_UPDATE_ACTION = 'CARD_ASSIGNEES_ASSIGNEE_UPDATE_ACTION';
export const AT_CARD_ASSIGNEE_ADD_ACTION = 'CARD_ASSIGNEES_ASSIGNEE_ADD_ACTION';
